import React, { useState } from 'react';
import { FaVideo, FaPhone, FaTimes } from 'react-icons/fa';

const CommunicationModePopup = ({ isOpen, onClose, onConfirm, selectedTime, selectedDate }) => {
  const [sessionMode, setSessionMode] = useState('video');

  const handleSubmit = () => {
    onConfirm(sessionMode);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Select Communication Mode
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        {/* Session Details */}
        <div className="mb-4 p-3 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-600 mb-1">Session Details:</p>
          <p className="text-sm font-medium text-gray-900">
            {selectedDate} at {selectedTime}
          </p>
        </div>

        {/* Communication Mode Selection */}
        <div className="space-y-3 mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            How would you like to connect?
          </label>
          
          <div className="space-y-3">
            <label className="flex items-center p-3 border border-gray-200 rounded-lg cursor-pointer hover:border-blue-300 transition-colors">
              <input
                type="radio"
                name="sessionMode"
                value="video"
                checked={sessionMode === 'video'}
                onChange={(e) => setSessionMode(e.target.value)}
                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <div className="ml-3 flex items-center">
                <FaVideo className="w-5 h-5 text-blue-500 mr-2" />
                <div>
                  <div className="text-sm font-medium text-gray-900">Video Call</div>
                  <div className="text-xs text-gray-500">Face-to-face consultation via video</div>
                </div>
              </div>
            </label>

            <label className="flex items-center p-3 border border-gray-200 rounded-lg cursor-pointer hover:border-blue-300 transition-colors">
              <input
                type="radio"
                name="sessionMode"
                value="phone"
                checked={sessionMode === 'phone'}
                onChange={(e) => setSessionMode(e.target.value)}
                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <div className="ml-3 flex items-center">
                <FaPhone className="w-5 h-5 text-blue-500 mr-2" />
                <div>
                  <div className="text-sm font-medium text-gray-900">Phone Call</div>
                  <div className="text-xs text-gray-500">Audio-only consultation</div>
                </div>
              </div>
            </label>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="flex-1 px-4 py-2 bg-blue-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Confirm Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommunicationModePopup;

